var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"tgbContextMenu",style:(_vm.menuStyles),on:{"contextmenu":function($event){$event.stopPropagation();}}},_vm._l((_vm.actions),function(action){return _c('li',{key:action.key,staticClass:"tgbContextMenuItem"},[_vm._t("default",null,null,action)],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }